export default {
    digitalLoyalty: 'DIGITAL_LOYALTY',
    physicalLoyalty: 'PHYSICAL_LOYALTY',
    dirty: 'DIRTY',
    updated: 'UPDATED',
    initialRetryNumber: 0,
};
